import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { fromLonLat } from 'ol/proj.js';
import { getVectorContext } from 'ol/render.js';
import { unByKey } from 'ol/Observable.js';
import { hexToRgba, settingsConfig } from 'utils/commonFunc';
import { reverseProgressValue, runAnimationFeature, runAnimationLayerList, setMapSingleEventHandler } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { ToFeatures } from 'services/GeoJsonService';

export default class CommonPoiLayer extends VectorLayer {

    constructor(map) {
        super({
            name: 'markerLayer',
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature)
        });
        this.map = map;
        this.setDefaultPoi()
    }

    getDefaultStyle = (feature) => {
        const nm = feature.get('properties')['nm'];
        return new Style({
            image: new RegularShape({
                radius: 6,
                points: 3,
                angle: Math.PI,
                displacement: [0, 0],
                fill: new Fill({
                    color: '#FFFFFF'
                }),
                stroke: new Stroke({
                    color: 'gray',
                    width: 1
                })
            }),
            text: new Text({
                font: "16px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                //scale: 2,
                offsetY: -12,
                text: nm,
                fill: new Fill({ color: '#FFFFFF' }),
                stroke: new Stroke({ color: 'gray', width: 1 })
            })
        })
    };

    setDefaultPoi = () => {
        const dataset = [
            { x: 127.02868404358908, y: 37.26342272244307, nm: '수원시청' },
            { x: 127.00992786753214, y: 37.303819180974784, nm: '장안구청' },
            { x: 126.97212686697105, y: 37.25735337428141, nm: '권선구청' },
            { x: 127.04627498345627, y: 37.259474844977746, nm: '영통구청' },
            { x: 127.01986274588474, y: 37.28261428009829, nm: '팔달구청' },
            { x: 127.04812716168492, y: 37.29933641836138, nm: '수원시도시안전통합센터' },

            { x: 126.99588355976813, y: 37.29742823512241, nm: '수원소방' },
            { x: 127.03681145970462, y: 37.25473198545381, nm: '남부소방' },
            { x: 127.05379228212482, y: 37.27235112419323, nm: '남부경찰' },
            
            { x: 127.0474, y: 37.2793, nm: '아주대병원' },
            { x: 127.0274, y: 37.2778, nm: '성빈센트병원' },
            { x: 126.9642, y: 37.2601, nm: '화홍병원' },
            { x: 127.0333, y: 37.2786, nm: '동수원병원' },
        ]
        const source = this.getSource()
        source.addFeatures(ToFeatures(dataset))
    }
}